<template>
  <div class="kt-header__topbar-item kt-header__topbar-item--search dropdown">
    <div id="global_search_toggle" class="kt-header__topbar-item kt-header__topbar-item--search dropdown">
      <div class="kt-header__topbar-wrapper" data-toggle="dropdown" data-offset="10px,0px">
        <span class="kt-header__topbar-icon">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
               width="24px"
               height="24px" viewBox="0 0 24 24"
               version="1.1" class="kt-svg-icon">
            <g stroke="none" stroke-width="1"
               fill="none"
               fill-rule="evenodd">
              <rect id="bound" x="0"
                    y="0"
                    width="24" height="24" />
              <path id="Path-2" d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                    fill="#000000"
                    fill-rule="nonzero" opacity="0.3" />
              <path id="Path" d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                    fill="#000000"
                    fill-rule="nonzero" />
            </g>
          </svg> </span>
      </div>
      <div id="global_search_dropdown" class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-lg">
        <div id="global_search_inline" class="kt-quick-search kt-quick-search--inline">
          <form method="get" class="kt-quick-search__form" @submit.prevent>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="la la-search" /></span>
              </div>
              <input v-model="search_query" type="text"
                     class="form-control"
                     :placeholder="`Search ${getItemLabel(true)}, ${getFeedLabel(true)}, etc`">
              <div class="input-group-append">
                <span v-if="!loading" class="input-group-text" @click="closeGlobalSearch()"><i class="la la-close" /></span>
                <span v-if="loading" class="kt-spinner kt-spinner--sm kt-spinner--brand" />
              </div>
            </div>
          </form>

          <div v-if="hasQueryResults" class="kt-quick-search__wrapper">
            <div class="kt-quick-search__result">
              <div v-for="(results, indexA) in search_results" :key="indexA">
                <div v-if="results.length">
                  <div class="kt-quick-search__category">
                    {{ translateCategoryName(indexA) }}
                  </div>
                  <div class="kt-quick-search__section">
                    <div v-for="(result, indexB) in results" :key="indexB" class="kt-quick-search__item">
                      <div class="kt-quick-search__item-wrapper">
                        <a :href="result.url" class="kt-quick-search__item-title">
                          {{ result.name }}
                        </a>
                        <div class="kt-quick-search__item-desc">
                          <p class="found-in">
                            {{ result.found_in }}
                          </p>
                          <p v-sanitise="contentMinifier(result.content)" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="!loading" class="kt-quick-search__wrapper message-wrapper">
            <strong class="message-content">No results</strong>
          </div>
          <div v-else class="kt-quick-search__wrapper message-wrapper">
            <span>Searching...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Debounce from "Lib/debounce";

export default {
  data() {
    return {
      search_query: null,
      search_results: false,
      loading: false,
      debounce: new Debounce(500, this.search),
    };
  },
  computed: {
    hasQueryResults() {
      if (!this.search_results) {
        return false;
      }

      let has_result = false;

      _.forEach(this.search_results, (results) => {
        if (results.length) {
          has_result = true;
        }
      });

      return has_result;
    },
  },
  watch: {
    search_query: function () {
      this.debounce.restart();
    },
  },
  methods: {
    translateCategoryName(name) {
      if (name === 'items') {
        return `${this.getItemLabel(true)}s`;
      }

      if (name === 'feeds') {
        return `${this.getFeedLabel(true)}s`;
      }

      return name;
    },
    closeGlobalSearch() {
      $('#global_search_dropdown').removeClass('show');
    },
    search() {
      this.loading = true;
      axios.get(`/api/v1/global-search?q=${this.search_query}`).then((response) => {
        this.search_results = response.data.data;
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        window.handleAxiosError(error);
      });
    },
    contentMinifier(value) {
      if (value.length < 100) return this.markQueryInString(value);
      const first_occurrence_of_search_string = value.indexOf(this.search_query);
      const search_query_length = this.search_query.length;
      const characters_before = value.substring(first_occurrence_of_search_string, -50);
      const characters_after = value.substring(first_occurrence_of_search_string + search_query_length, 50);
      let result_string = characters_before + this.search_query + characters_after;

      if (first_occurrence_of_search_string - 50 > 0) {
        result_string = '[...] ' + result_string;
      }

      if (first_occurrence_of_search_string + search_query_length + 50 < value.length) {
        result_string = result_string + ' [...]';
      }

      result_string = this.markQueryInString(result_string);

      return result_string;
    },
    markQueryInString(value) {
      return value.replace(new RegExp(this.search_query, 'g'), `<mark>${this.search_query}</mark>`);
    },
  },
};
</script>

<style lang="scss">
  @use "sass:map";

  @use "~AssetsSass/_variables" as *;

  #global_search_inline {

    .kt-quick-search__form {
      border-bottom:1px solid #ccc;
    }

    .kt-quick-search__wrapper {
      display: block;
      height: 300px;
      padding: 10px;
      overflow: scroll;

      &.message-wrapper {
        text-align: center;
        .message-content {
          font-weight: bold;
          font-size: 1.2em;
        }
      }
    }

    .kt-quick-search.kt-quick-search--inline .kt-quick-search__wrapper {
      margin-top:0;
    }

    a.kt-quick-search__item-title {
      font-weight:bold;
      font-size:1rem;
      color:#000000;
    }

    .kt-quick-search__category {
      color: map.get($ss, 'primary') !important;
    }

    .kt-quick-search__item-wrapper {
      padding-left:1.5rem;
    }

    .kt-spinner {
      padding-right:15px;
    }

    .found-in {
      color:#595d6e !important;
      font-weight:bold;
      margin-bottom:0.25rem;
      text-transform: capitalize;
    }
  }
</style>
